import type { IntlNumberFormats } from 'vue-i18n'
import type { Locale } from '@/router/locales'

export const numberFormats = {
  no: {
    decimal: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
    integer: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
      maximumFractionDigits: 0,
    },
  },
  en: {
    decimal: {
      style: 'decimal',
      maximumFractionDigits: 2,
    },
    integer: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
    percent: {
      style: 'percent',
      maximumFractionDigits: 0,
    },
  },
} as const satisfies IntlNumberFormats<Record<string, Intl.NumberFormatOptions>, Locale>
